var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal select-none fixed inset-0 z-50 overflow-x-hidden overflow-y-auto"},[_c('div',{staticClass:"relative mx-auto z-20",class:{
            'px-4 py-8': !_vm.fullWidth,
            'bg-white min-h-full': _vm.fullWidth
        }},[_c('div',[_vm._t("default")],2)])])}
var staticRenderFns = []

export { render, staticRenderFns }